import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { setMessage } from "./message";
// import { setError } from "./error";

import userService from "../../services/userService";

export const getSettings = createAsyncThunk(
    "genealogy/getSettings",
    async () => {
        const response = await userService.getGenealogySettings();
        return response.data;
    }
);

export const updateSettings = createAsyncThunk(
    "genealogy/updateSettings",
    async ({ formData }) => {
        const response = await userService.updateGenealogySettings(formData);
        return response.data;
    }
);

const initialState = {
    position: '',
    loading: false
};

const genealogySlice = createSlice({
    name: "genealogy",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getSettings.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getSettings.fulfilled, (state, action) => {
            state.loading = false;
            state.position = action.payload.position;
        });
        builder.addCase(getSettings.rejected, (state, action) => {
            state.loading = false;
        });
        builder.addCase(updateSettings.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(updateSettings.fulfilled, (state, action) => {
            state.loading = false;
            state.position = action.payload.position;
        });
        builder.addCase(updateSettings.rejected, (state, action) => {
            state.loading = false;
        });
    }
});


export const getPosition = (state) => state.genealogy.position;
export const getLoading = (state) => state.genealogy.loading;
 
export default genealogySlice.reducer;